import { createSlice } from "@reduxjs/toolkit";
import adapter from "../program-form/adapter";
import { getInitialFormBasic } from "../program-form/slice";
import { fetchProgram } from "../program/slice";

const NAME = "programFormV1"

const initialFormEmpty = getInitialFormBasic()

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: initialFormEmpty,
  showBasicPopup: false,
  isEdit: false,

  partner: {
    partners: [],
    partners_external: [],
    active_form: 'internal', // internal || external
    form: {},
    partner_external_to_edit: {}
  }
};

export const programFormSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    updateForm(state, action){
      state.data[action.payload.key] = action.payload.value
    },
    reset(state){
      state.data = initialFormEmpty
    },
    setShowBasicPopup(state, action){
      state.showBasicPopup = action.payload
    },
    setIsEdit(state, action){
      state.isEdit = action.payload
    },

    // Partner
    setActivePartnerForm(state, action){
      state.partner.active_form = action.payload
    }
  },
  extraReducers: {
    [fetchProgram.fulfilled]: (state, action) => {
      const adapted = adapter.responseBodyToForm(action.payload)
      state.data = adapted
    },
  }
});

export const {
  setStatus,
  updateForm,
  reset,
  setShowBasicPopup,
  setIsEdit,
  setActivePartnerForm
} = programFormSlice.actions

export default programFormSlice.reducer;
